import React from "react"
import classnames from "classnames"
import * as layouts from "layouts"
import * as errors from "errors"
import * as api from "brandguard/api"
import * as bgscores from "brandguard/display/scores"
import { ScoreAccordionDescription } from "brandguard/components/layouts/scores"

interface props extends layouts.containers.FlexProps {
	event: api.ImageEvent | api.TextEvent | api.DocumentEvent | api.VideoEvent
}

export default function Display(props: React.PropsWithChildren<props>): JSX.Element {
	const { className, event, children, ...rest } = props
	const hasArtifact = !!event.artifact_match_description
	const hasOnbrand = "onbrand_score" in event && (event as api.ImageEvent).onbrand_score > 0

	if (!hasArtifact && !hasOnbrand) return <>{children}</>

	const onbrandScore = hasOnbrand ? (event as api.ImageEvent).onbrand_score : -1
	const onbrandPct = Math.round(onbrandScore * 100)

	return (
		<bgscores.SectionAccordion
			borderWidth="0"
			borderRadius="0"
			borderColor="unset"
			borderStyle="unset"
			borderBottom="none"
			my="0"
			className={classnames(className, bgscores.layouts.styledAccordion)}
			{...rest}
		>
			<layouts.containers.box tabIndex={0}>
				<bgscores.SectionDescription>
					<ScoreAccordionDescription padding="0" className={className}>
						{children}
					</ScoreAccordionDescription>
				</bgscores.SectionDescription>
				<layouts.accordions.Content>
					<layouts.Flex
						flexDirection="column"
						flex="1"
						pr="54px"
						className={classnames("brand_consistency_explanation.list", className)}
					>
						<errors.overlay styled cause={undefined} flex="1">
							<layouts.Flex flexDirection="column" my="10px" pl="35px" lineHeight="14px" gridGap="8px">
								{hasOnbrand && (
									<layouts.Box fontWeight="700">
										On-brand confidence: {onbrandPct}% — {onbrandPct >= 70 ? "This content aligns well with the brand's trained visual identity." : onbrandPct >= 40 ? "This content partially matches the brand's visual identity." : "This content does not match the brand's trained visual identity."}
									</layouts.Box>
								)}
								{hasArtifact && (
									<layouts.Box fontWeight="700">
										Artifact match: {event.artifact_match_description || ""}
										{event.artifact_match_training_id && ` (Training ID: ${event.artifact_match_training_id})`}
									</layouts.Box>
								)}
							</layouts.Flex>
						</errors.overlay>
					</layouts.Flex>
				</layouts.accordions.Content>
			</layouts.containers.box>
		</bgscores.SectionAccordion>
	)
}
